import { render, staticRenderFns } from "./AdminSelf.vue?vue&type=template&id=072f103f&"
import script from "./AdminSelf.vue?vue&type=script&lang=js&"
export * from "./AdminSelf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports